import {
    IElasticEventData
} from "../../../../../common/interfaces/structured-logging-service-interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

const EVENT_NAME = 'Orbit_User_Flow'

interface IReportApplyFiltersParams {
    appliedFilters: Record<string, string[]>; // the key is the filters category and the value is an array of applied filters from that category
    gamesCount: number;
}

interface IFilterEventData {
    action: string;
    actionData?: string;
}

export class AdvancedFiltersAnalytics {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    private _sendEvent(filterEventData: IFilterEventData): void {

        let location = this.services.location.currentUri.pathName.toString()
        if(location !== '/' && location.endsWith('/')) {
            location = location.substr(0, location.length - 1)
        }

        const eventData: IElasticEventData = {
            CGPEventLabel: location,
            CGPEventCategory: 'advanced-filters',
            CGPEventAction: filterEventData.action,
        }

        if(filterEventData.actionData) {
            eventData.actionData = filterEventData.actionData;
        }

        this.services.analytics.getLogger(eventData)
            .setEventType(EVENT_NAME, 'Log', 'Analytics')
            .info();
    }


    reportOpenFilters(): void {
        this._sendEvent({
            action: 'open'
        });
    }

    reportCloseFilters(): void {
        this._sendEvent({
            action: 'close'
        });
    }

    reportClearFilters(): void {
        this._sendEvent({
            action: 'clear'
        });
    }

    reportApplyFilters(params: IReportApplyFiltersParams): void {
        this._sendEvent({
            action: 'apply',
            actionData: JSON.stringify(params)
        });
    }
}